import type { IconData } from '@stacksjs/iconify-core'

export const interfaceEssentialCloundDownload: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M30.47 12.195H32v6.09h-1.53Zm-1.52 6.09h1.52v1.53h-1.52Zm0-7.62h1.52v1.53h-1.52Zm-1.52 9.15h1.52v1.52h-1.52Zm0-10.67h1.52v1.52h-1.52Zm-3.05-1.52v-1.53h-1.53v3.05h4.58v-1.52zm-3.05 13.71h6.1v1.52h-6.1Zm0-12.19h1.52v1.52h-1.52Zm0-4.57h1.52v1.52h-1.52Zm-1.52 6.09h1.52v1.53h-1.52Zm-1.53-7.62h3.05v1.53h-3.05Zm-4.57 16.77v4.57h-3.05v1.52h1.53v1.52h1.52v1.53h1.53v1.52h1.52v-1.52h1.52v-1.53h1.53v-1.52h1.52v-1.52h-3.05v-4.57zm0-18.29h4.57v1.52h-4.57Zm-3.05 10.67h1.53v1.52h-1.53Zm0-9.15h3.05v1.53h-3.05Zm-1.52 7.62h1.52v1.53H9.14Zm0-6.09h1.52v1.52H9.14Zm-1.52 4.57H3.05v1.52h6.09v-4.57H7.62zm-4.57 12.19h7.61v1.52H3.05Zm-1.53-1.52h1.53v1.52H1.52Zm0-9.15h1.53v1.53H1.52ZM0 12.195h1.52v7.62H0Z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default interfaceEssentialCloundDownload
